/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomerFilterOption {
    ALL = 'All',
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
}
